export default class Dev {
  constructor(Vue) {
    this.portal = Vue.prototype.$portal;
    this.company = Vue.prototype.$company;
    Vue.prototype.$brain.dev = this;
    this.init();
  }

  init() {
    [this.domain] = window.location.href
      .replace('http://www.', '')
      .replace('https://www.', '')
      .replace('http://', '')
      .replace('https://', '')
      .replace(':8085', '')
      .replace(':8081', '')
      .replace(':80', '')
      .replace(':7171', '')
      .split('/');
    this.is = '';
  }

  check() {
    return new Promise((resolve, reject) => {
      /*
        IDENTIFICA QUAL AMBIENTE O SISTEMA ESTÁ SENDO INICIADO, ACIONANDO SUA
        RESPECTIVA FUNÇÃO DE INICIALIZAÇÃO.
      */
      if (this.domain.indexOf('localhost') >= 0)
        return this.initDev(() => resolve());
      this.initProduction(() => resolve());
    });
  }

  /*
    FUNÇÃO DE START PARA O SISTEMA EM DESENVOLVIMENTO
  */
  initDev(cb) {
    /* CONFIGURA O CAMINHO DO SERVERLESS PARA LOCAL */
    this.portal.url.endPoint.core = 'http://localhost:3042';
    this.portal.url.endPoint.app = 'http://localhost:3010/api/app';
    this.portal.url.endPoint.auth = 'http://localhost:3011/api/auth';
    this.portal.url.endPoint.access = 'http://localhost:3012/api/access';
    this.portal.url.endPoint.activity = 'http://localhost:3013/api/activity';
    this.portal.url.endPoint.remoteSql = 'http://localhost:3015/api/remotesql';
    this.portal.url.endPoint.admin = 'http://localhost:3016/api/pro-admin';
    this.portal.url.endPoint.file = 'http://localhost:3017/api/file';
    this.portal.url.endPoint.dfe = 'http://localhost:3019/api/dfe';
    this.portal.url.endPoint.paymentReminder = 'http://localhost:3020/api/payment-reminder';
    this.portal.url.endPoint.marketing = 'http://localhost:3022/marketing';
    this.portal.url.endPoint.faccionista = 'http://localhost:3023/faccionista';
    this.portal.url.endPoint.devolution = 'http://localhost:3024/api/devolution';
    this.portal.url.endPoint.bankbill = 'http://localhost:3026/api/bankbill';
    this.portal.url.endPoint.bankbill_partners = 'http://localhost:3043/api/bankbill-partners';
    this.portal.url.endPoint.shipping = 'http://localhost:3046/api/shipping';
    this.portal.url.endPoint.quotas = 'http://localhost:3047/api/quotas';
    this.portal.url.endPoint.orders = 'http://localhost:3048/api/orders';
    this.portal.url.endPoint.store_liveshop = 'http://localhost:3029/store/live';
    this.portal.url.endPoint.store_liveshop_guest = 'http://localhost:3034/store/live-guest';
    this.portal.url.endPoint.store_liveshop_tags = 'http://localhost:3035/store/live-tags';
    this.portal.url.endPoint.store_liveshop_order = 'http://localhost:3036/store/live-order';
    this.portal.url.endPoint.store_liveshop_jobs = 'http://localhost:3037/store/live-jobs';
    this.portal.url.endPoint.store_liveshop_participant = 'http://localhost:3038/store/live-participant';
    this.portal.url.endPoint.store_cart = 'http://localhost:3030/store/cart';
    this.portal.url.endPoint.store_product = 'http://localhost:3031/store/product';
    this.portal.url.endPoint.store_resources = 'http://localhost:3032/store/resources';
    this.portal.url.endPoint.store_campaign_products = 'http://localhost:3039/store/campaign-products';
    this.portal.url.endPoint.ws_store_liveshop = 'ws://localhost:4000';
    this.portal.url.endPoint.paymentNegotiation = 'http://localhost:3033/payment-negotiation';
    this.portal.url.endPoint.custom_features = 'http://localhost:3014/custom-features';
    this.portal.url.endPoint.supplier_financial = 'http://localhost:3062/api/supplier-financial';
    this.portal.url.endPoint.supplier_order = 'http://localhost:3063/api/supplier-order';
    this.portal.url.endPoint.notifications = 'http://localhost:3044/api/notifications';
    this.portal.url.endPoint.ws_notifications = 'ws://localhost:4002';
    this.portal.url.endPoint.help = 'http://localhost:3058/api/help';
    this.portal.url.endPoint.chatbot_integration = 'http://localhost:3049/api/chatbot-integration';
    this.portal.url.endPoint.financial = 'http://localhost:3054/api/financial';
    this.portal.url.endPoint.customer_service = 'http://localhost:3056/api/customer-service';
    this.portal.url.endPoint.ws_customer_service = 'ws://localhost:4001 ';
    this.portal.url.endPoint.invoice = 'http://localhost:3059/api/invoice';
    this.portal.url.endPoint.permission = 'http://localhost:3055/api/permission';
    this.portal.url.endPoint.payment = 'http://localhost:3063/api/payment';
    this.portal.url.endPoint.chatbot = 'http://localhost:3053/api/chatbot';
    this.portal.url.endPoint.notification_automation = 'http://localhost:3006/api';

    /* CONFIGURA O SCRIPT PARA LOCAL */
    this.portal.url.script = 'static/script/';

    /* CONFIGURA A COMPANY PARA BAIXAR UM OBJ DE COMPANY LOCAL */
    this.company.locationJson = `static/${this.domain}`;

    /* SETA A FLAG PARA SEU RESPECTIVO START */
    this.is = 'DEV';
    cb();
  }

  /*
    FUNÇÃO DE START PARA O SISTEMA EM PRODUÇÃO
  */
  initProduction(cb) {
    /* SETA A FLAG PARA SEU RESPECTIVO START */
    this.is = 'PROD';
    cb();
  }
}
